(()=>{
  const $=(s,c=document)=>c.querySelector(s);
  const $$=(s,c=document)=>[...c.querySelectorAll(s)];
  const money=(cents)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}};
  const escapeHTML=(value='')=>String(value).replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]));

  /* ---------- Luxury desktop mega menu ---------- */
  const siteHeader=$('[data-site-header]');
  const siteHeaderSection=siteHeader?.closest('.shopify-section');
  if(siteHeaderSection)siteHeaderSection.classList.add('site-header-section-sticky');
  const megaItems=$$('[data-mega-item]',siteHeader||document);
  let megaCloseTimer;
  const syncMegaTop=()=>{
    if(!siteHeader)return;
    document.documentElement.style.setProperty('--starluxe-header-bottom',`${siteHeader.getBoundingClientRect().bottom}px`);
  };
  const closeMega=(except=null)=>{
    megaItems.forEach(item=>{
      if(item===except)return;
      item.classList.remove('is-mega-open');
      const trigger=$('[data-mega-trigger]',item),panel=$('[data-mega-panel]',item);
      trigger?.setAttribute('aria-expanded','false');
      panel?.setAttribute('aria-hidden','true');
    });
  };
  const openMega=(item)=>{
    if(!item||!$('[data-mega-panel]',item))return;
    clearTimeout(megaCloseTimer);syncMegaTop();closeMega(item);
    item.classList.add('is-mega-open');
    $('[data-mega-trigger]',item)?.setAttribute('aria-expanded','true');
    $('[data-mega-panel]',item)?.setAttribute('aria-hidden','false');
  };
  const scheduleMegaClose=(item)=>{clearTimeout(megaCloseTimer);megaCloseTimer=setTimeout(()=>{item.classList.remove('is-mega-open');$('[data-mega-trigger]',item)?.setAttribute('aria-expanded','false');$('[data-mega-panel]',item)?.setAttribute('aria-hidden','true')},320)};
  megaItems.forEach(item=>{
    const trigger=$('[data-mega-trigger]',item),panel=$('[data-mega-panel]',item);
    if(!trigger||!panel)return;
    item.addEventListener('mouseenter',()=>openMega(item));
    item.addEventListener('mouseleave',()=>scheduleMegaClose(item));
    panel.addEventListener('mouseenter',()=>{clearTimeout(megaCloseTimer);openMega(item)});
    panel.addEventListener('mouseleave',()=>scheduleMegaClose(item));
    trigger.addEventListener('click',e=>{
      if(window.matchMedia('(min-width:990px)').matches){
        e.preventDefault();
        if(item.classList.contains('is-mega-open')){scheduleMegaClose(item)}else{openMega(item)}
      }
    });
    trigger.addEventListener('keydown',e=>{
      if(['ArrowDown','Enter',' '].includes(e.key) && !item.classList.contains('is-mega-open')){e.preventDefault();openMega(item);$('a,button',panel)?.focus()}
    });
  });
  document.addEventListener('click',e=>{if(siteHeader&&!siteHeader.contains(e.target))closeMega()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeMega();closeMobileMenu()}});
  window.addEventListener('resize',()=>{syncMegaTop();if(window.innerWidth<990)closeMega()},{passive:true});
  const syncCompactHeader=()=>{
    if(!siteHeader)return;
    siteHeader.classList.toggle('is-compact',window.scrollY>100);
    syncMegaTop();
  };
  window.addEventListener('scroll',syncCompactHeader,{passive:true});
  syncCompactHeader();

  /* ---------- Multi-level mobile navigation ---------- */
  const mobileShell=$('[data-mobile-menu]');
  const mobileDrawer=$('.mobile-nav-drawer',mobileShell||document);
  const mobilePanels=$$('[data-nav-panel]',mobileShell||document);
  const menuOpenButtons=$$('[data-menu-open]');
  const menuCloseButtons=$$('[data-menu-close]');
  let navStack=['root'];
  function showMobilePanel(id,direction='forward'){
    mobilePanels.forEach(panel=>panel.classList.toggle('is-active',panel.dataset.navPanel===id));
    if(mobileDrawer){mobileDrawer.dataset.direction=direction;mobileDrawer.scrollTop=0}
  }
  function openMobileMenu(){
    if(!mobileShell)return;
    navStack=['root'];showMobilePanel('root');
    mobileShell.classList.add('is-open');mobileShell.setAttribute('aria-hidden','false');
    menuOpenButtons.forEach(b=>b.setAttribute('aria-expanded','true'));
    document.body.classList.add('nav-open');document.body.style.overflow='hidden';
    setTimeout(()=>$('.mobile-nav-panel.is-active a,.mobile-nav-panel.is-active button',mobileShell)?.focus(),180);
  }
  function closeMobileMenu(){
    if(!mobileShell)return;
    mobileShell.classList.remove('is-open');mobileShell.setAttribute('aria-hidden','true');
    menuOpenButtons.forEach(b=>b.setAttribute('aria-expanded','false'));
    document.body.classList.remove('nav-open');document.body.style.overflow='';
  }
  menuOpenButtons.forEach(b=>b.addEventListener('click',openMobileMenu));
  menuCloseButtons.forEach(b=>b.addEventListener('click',closeMobileMenu));
  $$('[data-nav-next]',mobileShell||document).forEach(b=>b.addEventListener('click',()=>{const id=b.dataset.navNext;navStack.push(id);showMobilePanel(id,'forward')}));
  $$('[data-nav-back]',mobileShell||document).forEach(b=>b.addEventListener('click',()=>{const id=b.dataset.navBack;while(navStack.length>1&&navStack[navStack.length-1]!==id)navStack.pop();if(navStack[navStack.length-1]!==id)navStack.push(id);showMobilePanel(id,'back')}));

  /* ---------- Mobile collection subnav comfort ---------- */
  const syncMobileSubnav=()=>{
    if(!window.matchMedia('(max-width:989px)').matches)return;
    const rail=document.querySelector('.template-collection .collection-subnav__inner, .template-collection .collection-subnav__scroll');
    const active=rail?.querySelector('.subnav-pill.is-active');
    if(rail&&active){
      const target=Math.max(0,active.offsetLeft-(rail.clientWidth-active.offsetWidth)/2);
      rail.scrollTo({left:target,behavior:'smooth'});
    }
  };
  window.setTimeout(syncMobileSubnav,120);

  /* ---------- Native Shopify navigation ---------- */
  // Navigation links are not intercepted or rewritten. Shopify Navigation link.url is the source of truth.

  /* ---------- Predictive search ---------- */
  const searchShell=$('[data-predictive-search]');
  const searchInput=$('[data-search-input]',searchShell||document);
  const searchResults=$('[data-search-results]',searchShell||document);
  const searchFooter=$('[data-search-footer]',searchShell||document);
  const searchViewAll=$('[data-search-view-all]',searchShell||document);
  const searchOpenButtons=$$('[data-search-open]');
  const searchCloseButtons=$$('[data-search-close]',searchShell||document);
  let searchController=null,searchTimer=null;
  const openSearch=()=>{
    if(!searchShell)return;
    syncMegaTop();closeMega();
    searchShell.classList.add('is-open');searchShell.setAttribute('aria-hidden','false');
    searchOpenButtons.forEach(b=>b.setAttribute('aria-expanded','true'));
    document.body.classList.add('search-open');
    setTimeout(()=>searchInput?.focus(),120);
  };
  const closeSearch=()=>{
    if(!searchShell)return;
    searchShell.classList.remove('is-open');searchShell.setAttribute('aria-hidden','true');
    searchOpenButtons.forEach(b=>b.setAttribute('aria-expanded','false'));
    document.body.classList.remove('search-open');
  };
  searchOpenButtons.forEach(b=>b.addEventListener('click',openSearch));
  searchCloseButtons.forEach(b=>b.addEventListener('click',closeSearch));
  const runPredictiveSearch=async(query)=>{
    const q=query.trim();
    if(!q){if(searchResults)searchResults.innerHTML='<div class="starluxe-search__empty">Start typing to discover products and collections.</div>';if(searchFooter)searchFooter.hidden=true;return}
    searchController?.abort();searchController=new AbortController();
    try{
      const base=searchShell?.dataset.predictiveUrl||'/search/suggest';
      const url=`${base}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
      const html=await fetch(url,{signal:searchController.signal,headers:{Accept:'text/html'}}).then(r=>r.text());
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('.predictive-results');
      if(searchResults)searchResults.innerHTML=fresh?fresh.outerHTML:'<div class="starluxe-search__empty">No matching products or collections found.</div>';
      if(searchViewAll)searchViewAll.href=`/search?q=${encodeURIComponent(q)}`;
      if(searchFooter)searchFooter.hidden=false;
    }catch(e){if(e.name!=='AbortError'&&searchResults)searchResults.innerHTML='<div class="starluxe-search__empty">Search is temporarily unavailable. Press Enter to see all results.</div>'}
  };
  searchInput?.addEventListener('input',()=>{clearTimeout(searchTimer);searchTimer=setTimeout(()=>runPredictiveSearch(searchInput.value),180)});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&searchShell?.classList.contains('is-open'))closeSearch()});

  /* ---------- Cart drawer ---------- */
  const drawer=$('#StarluxeCartDrawer');
  const openDrawer=()=>{drawer?.classList.add('is-open');drawer?.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';refreshCart()};
  const closeDrawer=()=>{drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');document.body.style.overflow=''};
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',openDrawer));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click',closeDrawer));
  async function refreshCart(){
    if(!drawer)return;
    try{
      const cart=await fetch('/cart.js').then(r=>r.json());
      $$('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);
      const body=$('[data-cart-drawer-body]',drawer),foot=$('[data-cart-drawer-footer]',drawer),recs=$('[data-cart-drawer-recommendations]',drawer);
      const progressCopy=$('[data-cart-progress-copy]',drawer),progressBar=$('[data-cart-progress-bar]',drawer);
      if(progressCopy) progressCopy.textContent='FREE SHIPPING ON EVERY ORDER';
      if(progressBar) progressBar.style.width='100%';
      if(!cart.items.length){
        body.innerHTML='<div class="cart-drawer__empty"><div class="cart-drawer__empty-icon">◇</div><h3>Your bag is empty</h3><p>Add something you love and it will appear here.</p></div>';
        if(recs){recs.hidden=true;recs.innerHTML=''}
        foot.innerHTML='<a class="button button--dark button--full" href="/collections/all">CONTINUE SHOPPING</a>';
        return
      }
      body.innerHTML=cart.items.map((i,index)=>`<div class="drawer-line" data-cart-line data-line="${index+1}">
        <a class="drawer-line__image" href="${i.url}"><img src="${i.image||''}" alt="${String(i.product_title||'').replace(/"/g,'&quot;')}"></a>
        <div class="drawer-line__info"><a href="${i.url}"><strong>${i.product_title}</strong></a><small>${i.variant_title||''}</small>
          <div class="drawer-line__qty"><button type="button" data-cart-qty-minus aria-label="Decrease quantity">−</button><span>${i.quantity}</span><button type="button" data-cart-qty-plus aria-label="Increase quantity">+</button></div>
        </div>
        <div class="drawer-line__end"><button type="button" class="drawer-line__remove" data-cart-remove aria-label="Remove ${String(i.product_title||'item').replace(/"/g,'&quot;')}">×</button><strong>${money(i.final_line_price)}</strong></div>
      </div>`).join('');
      const checkoutLabel=drawer.dataset.checkoutLabel||'CHECKOUT',viewLabel=drawer.dataset.viewLabel||'VIEW CART',note=drawer.dataset.checkoutNote||'';
      const shippingLabel=drawer.dataset.shippingTabLabel||'SHIPPING',shippingText=drawer.dataset.shippingTabText||'Shipping is complimentary.',returnsLabel=drawer.dataset.returnsTabLabel||'RETURNS',returnsText=drawer.dataset.returnsTabText||'See our return policy for details.';
      foot.innerHTML=`<div class="cart-drawer__subtotal"><span>Subtotal (${cart.item_count} ${cart.item_count===1?'item':'items'})</span><strong>${money(cart.total_price)}</strong></div>${note?`<p class="cart-drawer__note">${escapeHTML(note)}</p>`:''}<a class="button button--dark button--full cart-drawer__checkout" data-checkout-link href="/checkout">${escapeHTML(checkoutLabel)}</a><a class="button button--outline button--full cart-drawer__view" href="/cart">${escapeHTML(viewLabel)}</a><div class="cart-drawer__trust" aria-label="Shopping reassurance"><div class="cart-drawer__trust-item"><span class="cart-drawer__trust-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg></span><span><strong>${escapeHTML(shippingLabel)}</strong><small>${escapeHTML(shippingText)}</small></span></div><div class="cart-drawer__trust-item"><span class="cart-drawer__trust-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7h10l2 3v8H7z"/><path d="M7 10H4l2.5-2.5M4 10l2.5 2.5"/><path d="M10 7V5h5v2"/></svg></span><span><strong>${escapeHTML(returnsLabel)}</strong><small>${escapeHTML(returnsText)}</small></span></div></div>`;
      const activeCode=localStorage.getItem('starluxeDiscountCode');const checkout=$('[data-checkout-link]',foot);if(checkout&&activeCode)checkout.href=`/checkout?discount=${encodeURIComponent(activeCode)}`;
      if(recs&&drawer.dataset.showRecommendations==='true'&&cart.items[0]?.product_id){
        const recLimit=Math.max(2,Math.min(6,+(drawer.dataset.recommendationsLimit||4)));
        const recHeading=drawer.dataset.recommendationsHeading||'YOU MAY ALSO LIKE';
        try{
          const data=await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(cart.items[0].product_id)}&limit=${recLimit}&intent=related`).then(r=>r.ok?r.json():Promise.reject(new Error('recommendations unavailable')));
          const products=(data.products||[]).slice(0,recLimit);
          if(products.length){
            recs.hidden=false;
            recs.innerHTML=`<div class="cart-drawer__recommendations-head"><span>${escapeHTML(recHeading)}</span></div><div class="cart-drawer__recommendations-row">${products.map(p=>{const img=typeof p.featured_image==='string'?p.featured_image:(p.featured_image?.url||p.images?.[0]||'');return `<a class="cart-rec-card" href="${escapeHTML(p.url||'#')}"><span class="cart-rec-card__image">${img?`<img src="${escapeHTML(img)}${String(img).includes('?')?'&':'?'}width=240" alt="${escapeHTML(p.title)}" loading="lazy">`:''}</span><strong>${escapeHTML(p.title)}</strong><small>${money(p.price||0)}</small></a>`}).join('')}</div>`;
          }else{recs.hidden=true;recs.innerHTML=''}
        }catch(e){recs.hidden=true;recs.innerHTML=''}
      }else if(recs){recs.hidden=true;recs.innerHTML=''}
      $$('[data-cart-line]',body).forEach(line=>{
        const lineNumber=+line.dataset.line;const item=cart.items[lineNumber-1];
        const change=async quantity=>{try{await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:lineNumber,quantity})});await refreshCart()}catch(e){console.error(e)}};
        $('[data-cart-qty-minus]',line)?.addEventListener('click',()=>change(Math.max(0,item.quantity-1)));
        $('[data-cart-qty-plus]',line)?.addEventListener('click',()=>change(item.quantity+1));
        $('[data-cart-remove]',line)?.addEventListener('click',()=>change(0));
      });
    }catch(e){console.error(e)}
  }

  /* ---------- Collection filters ---------- */
  const filterDrawer=$('[data-filter-drawer]');
  $('[data-filter-open]')?.addEventListener('click',()=>filterDrawer?.classList.add('is-open'));
  $('[data-filter-close]')?.addEventListener('click',()=>filterDrawer?.classList.remove('is-open'));

  /* ---------- Product ---------- */
  $$('[data-product-section]').forEach(section=>{
    const form=$('[data-product-form]',section);if(!form)return;
    const json=$('[data-product-json]',section);if(!json)return;
    const variants=JSON.parse(json.textContent);
    const hidden=$('[data-variant-id]',form),atc=$('[data-atc-text]',form),atcPrice=$('[data-atc-price]',form),price=$('[data-product-price]',section),compare=$('[data-compare-price]',section),sale=$('[data-sale-savings]',section),stickyPrice=$('[data-sticky-price]');
    const quantityInput=$('[data-quantity-input]',form);
    let current=variants.find(v=>String(v.id)===String(hidden.value))||variants[0];
    const selectedOptions=()=>$$('.variant-group',form).map(g=>$('input:checked',g)?.value);
    const updateSelectedLabels=()=>$$('.variant-group',form).forEach(g=>{const out=$('[data-selected-option]',g),checked=$('input:checked',g);if(out&&checked)out.textContent=checked.value});
    function updateTiers(){const base=current.price;$$('[data-tier-price]',section).forEach(el=>{const qty=+el.dataset.tierPrice,box=el.closest('.bundle-box'),radio=$(`input[name=\"bundle-tier\"][value=\"${qty}\"]`,box),d=+(radio?.dataset.discount||0),each=Math.round(base*(1-d/100));el.textContent=money(each)+' each';const total=$(`[data-tier-total=\"${qty}\"]`,box);if(total)total.textContent=money(each*qty)})}
    const thumbs=$$('[data-thumb]',section),v80Media=$$('[data-v80-media]',section),primaryImage=$('[data-pdp-primary-image]',section);let activeMediaIndex=Math.max(0,thumbs.findIndex(t=>t.classList.contains('is-active')));
    function activateMedia(index){
      if(!thumbs.length)return;activeMediaIndex=(index+thumbs.length)%thumbs.length;
      thumbs.forEach((t,i)=>t.classList.toggle('is-active',i===activeMediaIndex));
      if(v80Media.length){
        v80Media.forEach((m,i)=>{const on=i===activeMediaIndex;m.hidden=!on;m.classList.toggle('is-active',on)});
      }else{
        const thumb=thumbs[activeMediaIndex];
        if(primaryImage&&thumb?.dataset.imageSrc){primaryImage.src=thumb.dataset.imageSrc;primaryImage.removeAttribute('srcset');primaryImage.alt=thumb.querySelector('img')?.alt||primaryImage.alt||'';}
      }
      const thumb=thumbs[activeMediaIndex];
      thumb?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    }
    function showVariantMedia(){
      const mediaId=current.featured_media?.id||current.featured_image?.id;
      if(!mediaId)return;
      const index=thumbs.findIndex(t=>String(t.dataset.mediaId)===String(mediaId));
      if(index>=0)activateMedia(index);
    }
    function resolve(){
      const opts=selectedOptions();
      current=variants.find(v=>v.options.every((o,i)=>o===opts[i]))||current;
      hidden.value=current.id;
      if(price)price.textContent=money(current.price);
      if(atcPrice)atcPrice.textContent=money(current.price);
      if(stickyPrice)stickyPrice.textContent=money(current.price);
      if(atc)atc.textContent=current.available?'ADD TO BAG':'SOLD OUT';
      const atcButton=$('.product-atc',form);if(atcButton)atcButton.disabled=!current.available;
      const compareValue=current.compare_at_price||0;
      if(compare){compare.textContent=compareValue?money(compareValue):'';compare.classList.toggle('is-hidden',!(compareValue>current.price))}
      if(sale){const pct=compareValue>current.price?Math.round((compareValue-current.price)*100/compareValue):0;sale.textContent=pct?`SAVE ${pct}%`:'';sale.classList.toggle('is-hidden',!pct)}
      updateSelectedLabels();updateTiers();showVariantMedia();
    }
    $$('.variant-group input',form).forEach(i=>i.addEventListener('change',resolve));updateSelectedLabels();updateTiers();

    const bundleRadios=$$('input[name="bundle-tier"]',section);
    const bundleCards=$$('[data-bundle-tier]',section);
    const paintBundleSelection=()=>bundleRadios.forEach(r=>{
      const card=r.closest('.bundle-tier');
      card?.classList.toggle('is-selected',r.checked);
      card?.setAttribute('aria-pressed',r.checked?'true':'false');
    });
    const setProductQuantity=(qty,{syncBundle=false}={})=>{
      if(!quantityInput)return;
      const next=Math.max(1,parseInt(qty,10)||1);
      quantityInput.value=next;
      quantityInput.setAttribute('value',String(next));
      quantityInput.dispatchEvent(new Event('input',{bubbles:true}));
      quantityInput.dispatchEvent(new Event('change',{bubbles:true}));
      if(syncBundle)syncQuantityToBundle();
    };
    const syncBundleToQuantity=radio=>{
      if(!radio)return;
      const qty=Math.max(1,+radio.value||1);
      radio.checked=true;
      paintBundleSelection();
      setProductQuantity(qty);
    };
    const syncQuantityToBundle=()=>{
      if(!quantityInput||!bundleRadios.length)return;
      const qty=Math.max(1,+quantityInput.value||1);
      const exact=bundleRadios.find(r=>+r.value===qty);
      bundleRadios.forEach(r=>r.checked=(r===exact || (!exact && +r.value===1)));
      paintBundleSelection();
    };
    bundleRadios.forEach(r=>r.addEventListener('change',()=>syncBundleToQuantity(r)));
    bundleCards.forEach(card=>{
      const radio=$('input[name="bundle-tier"]',card);
      const activate=e=>{
        if(e.type==='keydown' && !['Enter',' '].includes(e.key))return;
        if(e.type==='keydown')e.preventDefault();
        if(radio)syncBundleToQuantity(radio);
      };
      card.addEventListener('click',e=>{
        if(e.target===radio)return;
        activate(e);
      });
      card.addEventListener('keydown',activate);
    });
    $('[data-qty-minus]',form)?.addEventListener('click',()=>{if(quantityInput)setProductQuantity((+quantityInput.value||1)-1,{syncBundle:true});});
    $('[data-qty-plus]',form)?.addEventListener('click',()=>{if(quantityInput)setProductQuantity((+quantityInput.value||1)+1,{syncBundle:true});});
    quantityInput?.addEventListener('change',syncQuantityToBundle);
    quantityInput?.addEventListener('input',syncQuantityToBundle);
    const initiallySelected=$('input[name="bundle-tier"]:checked',section);
    if(initiallySelected)syncBundleToQuantity(initiallySelected);else paintBundleSelection();

    form.addEventListener('submit',async e=>{
      e.preventDefault();if(!current.available)return;
      const selected=$('input[name="bundle-tier"]:checked',section);
      const tierQty=selected?+selected.value:1;
      const qty=tierQty>1?tierQty:Math.max(1,+quantityInput?.value||1);
      const code=(selected?.dataset.discountCode||'').trim();
      if(code)localStorage.setItem('starluxeDiscountCode',code);else localStorage.removeItem('starluxeDiscountCode');
      const fd=new FormData(form);fd.set('quantity',qty);
      const button=$('.product-atc',form);button.disabled=true;
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});if(!res.ok)throw new Error('Add failed');
        await refreshCart();if(drawer)openDrawer();else location.href='/cart';
      }catch(err){alert('Unable to add this item. Please review your selections and try again.')}finally{button.disabled=false}
    });
    $('[data-sticky-submit]')?.addEventListener('click',()=>form.requestSubmit());
    thumbs.forEach((b,i)=>b.addEventListener('click',()=>activateMedia(i)));
    $('[data-gallery-prev]',section)?.addEventListener('click',()=>activateMedia(activeMediaIndex-1));
    $('[data-gallery-next]',section)?.addEventListener('click',()=>activateMedia(activeMediaIndex+1));

    const lightbox=$('[data-product-lightbox]',section),lightboxImage=$('[data-lightbox-image]',section);
    const openCurrentLightbox=()=>{
      if(!lightbox||!lightboxImage||!thumbs.length)return;
      const thumb=thumbs[activeMediaIndex],activeV80=v80Media[activeMediaIndex]?.querySelector('img');
      lightboxImage.src=activeV80?.currentSrc||activeV80?.src||thumb?.querySelector('img')?.currentSrc||thumb?.querySelector('img')?.src||primaryImage?.src||'';
      lightbox.classList.add('is-open');lightbox.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';
    };
    primaryImage?.addEventListener('click',openCurrentLightbox);
    $('[data-gallery-zoom-current]',section)?.addEventListener('click',openCurrentLightbox);
    $$('[data-lightbox-close]',section).forEach(btn=>btn.addEventListener('click',()=>{lightbox?.classList.remove('is-open');lightbox?.setAttribute('aria-hidden','true');document.body.style.overflow=''}));

    const guide=$('[data-size-guide-modal]',section);
    $$('[data-size-guide-open]',section).forEach(btn=>btn.addEventListener('click',()=>{guide?.classList.add('is-open');guide?.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'}));
    $$('[data-size-guide-close]',section).forEach(btn=>btn.addEventListener('click',()=>{guide?.classList.remove('is-open');guide?.setAttribute('aria-hidden','true');document.body.style.overflow=''}));

    const wish=$('[data-wishlist-toggle]',section);
    if(wish){
      const key='starluxeWishlist',handle=wish.dataset.productHandle;
      const get=()=>{try{return JSON.parse(localStorage.getItem(key)||'[]')}catch(e){return[]}};
      const sync=()=>{const saved=get().includes(handle);wish.classList.toggle('is-saved',saved);wish.setAttribute('aria-pressed',saved?'true':'false');$('span',wish).textContent=saved?'SAVED TO WISHLIST':'ADD TO WISHLIST';wish.firstChild.textContent=saved?'♥ ':'♡ '};
      wish.addEventListener('click',()=>{let list=get();list=list.includes(handle)?list.filter(h=>h!==handle):[...list,handle];localStorage.setItem(key,JSON.stringify(list));sync()});sync();
    }

    const sticky=$('[data-sticky-atc]');
    if(sticky){const mainAtc=$('.product-atc',form);if(mainAtc&&'IntersectionObserver'in window)new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:.15}).observe(mainAtc)}
  });

  document.addEventListener('keydown',e=>{if(e.key==='Escape'){$$('.product-lightbox.is-open,.size-guide-modal.is-open').forEach(m=>{m.classList.remove('is-open');m.setAttribute('aria-hidden','true')});if(!$('.mobile-nav-shell.is-open'))document.body.style.overflow=''}});
  $$('[data-product-recommendations]').forEach(async s=>{if(s.querySelector('.product-card'))return;try{const html=await fetch(s.dataset.url,{headers:{Accept:'text/html'}}).then(r=>r.text()),doc=new DOMParser().parseFromString(html,'text/html'),fresh=doc.querySelector('[data-product-recommendations]');if(fresh&&fresh.innerHTML.trim())s.innerHTML=fresh.innerHTML}catch(e){console.warn('Starluxe recommendations unavailable',e)}});
})();

/* V26 featured collection carousel controls */
document.querySelectorAll('[data-featured-collection]').forEach(section=>{
  const track=section.querySelector('[data-featured-track]');
  if(!track)return;
  const prev=section.querySelector('[data-featured-prev]');
  const next=section.querySelector('[data-featured-next]');
  const step=()=>Math.max(track.clientWidth*.82,260);
  const update=()=>{
    const hasOverflow=track.scrollWidth>track.clientWidth+8;
    [prev,next].forEach(btn=>btn?.classList.toggle('is-visible',hasOverflow));
    if(!hasOverflow)return;
    const max=Math.max(0,track.scrollWidth-track.clientWidth);
    if(prev)prev.disabled=track.scrollLeft<=4;
    if(next)next.disabled=track.scrollLeft>=max-4;
  };
  prev?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
  next?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
  track.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  if('ResizeObserver' in window)new ResizeObserver(update).observe(track);
  requestAnimationFrame(update);
});

/* ---------- V35 Product carousels, Complete the Look, Recently Viewed ---------- */
(()=>{
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
  const money=(cents)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}};
  const escapeHTML=(value='')=>String(value).replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]));
  const bindCarousel=(section)=>{
    if(section.dataset.carouselBound==='true')return;
    const track=$('[data-product-carousel-track]',section);if(!track)return;
    section.dataset.carouselBound='true';
    const prev=$('[data-product-carousel-prev]',section),next=$('[data-product-carousel-next]',section);
    const step=()=>Math.max(track.clientWidth*.82,280);
    const update=()=>{const overflow=track.scrollWidth>track.clientWidth+8;[prev,next].forEach(b=>b?.classList.toggle('is-visible',overflow&&window.innerWidth>=990));if(!overflow)return;const max=track.scrollWidth-track.clientWidth;if(prev)prev.disabled=track.scrollLeft<=4;if(next)next.disabled=track.scrollLeft>=max-4};
    prev?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));next?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});requestAnimationFrame(update);
  };
  $$('[data-product-carousel]').forEach(bindCarousel);
  const observer=new MutationObserver(()=>$$('[data-product-carousel]').forEach(bindCarousel));observer.observe(document.body,{childList:true,subtree:true});

  $$('[data-complete-look]').forEach(section=>{
    $('[data-add-look]',section)?.addEventListener('click',async e=>{
      const button=e.currentTarget,items=[];
      if($('[data-current-product]',section)){const currentId=document.querySelector('[data-product-form] [data-variant-id]')?.value;if(currentId)items.push({id:+currentId,quantity:1})}
      $$('[data-look-item][data-variant-id]',section).forEach(item=>{if(item.dataset.variantId)items.push({id:+item.dataset.variantId,quantity:1})});
      if(!items.length)return;
      button.disabled=true;const old=button.textContent;button.textContent='ADDING…';
      try{const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});if(!res.ok)throw new Error();button.textContent='ADDED TO BAG';setTimeout(()=>button.textContent=old,1500);document.querySelector('[data-cart-open]')?.click()}catch(err){button.textContent='PLEASE TRY AGAIN';setTimeout(()=>button.textContent=old,1800)}finally{button.disabled=false}
    });
  });

  $$('[data-recently-viewed]').forEach(async section=>{
    const current=section.dataset.currentHandle,limit=+(section.dataset.limit||5),key='starluxeRecentlyViewed';
    let handles=[];try{handles=JSON.parse(localStorage.getItem(key)||'[]')}catch(e){}
    handles=[current,...handles.filter(h=>h&&h!==current)].slice(0,10);localStorage.setItem(key,JSON.stringify(handles));
    const others=handles.filter(h=>h!==current).slice(0,limit),track=$('[data-recently-track]',section),shell=$('[data-recently-shell]',section);if(!others.length||!track||!shell)return;
    const products=(await Promise.all(others.map(async h=>{try{const r=await fetch(`/products/${encodeURIComponent(h)}.js`);return r.ok?await r.json():null}catch(e){return null}}))).filter(Boolean);
    if(!products.length)return;
    track.innerHTML=products.map(p=>`<article class="recently-viewed__card"><a href="${p.url}"><img loading="lazy" src="${p.featured_image||''}" alt="${String(p.title||'').replace(/"/g,'&quot;')}"><div class="recently-viewed__meta"><strong>${p.title}</strong><span>${money(p.price)}</span></div></a></article>`).join('');
    shell.hidden=false;section.setAttribute('data-product-carousel','');bindCarousel(section);
  });

  const applyDiscountLinks=()=>{const code=localStorage.getItem('starluxeDiscountCode');$$('[data-checkout-link]').forEach(a=>{a.href=code?`/checkout?discount=${encodeURIComponent(code)}`:'/checkout'})};applyDiscountLinks();document.addEventListener('click',e=>{if(e.target.closest('[data-checkout-link]'))applyDiscountLinks()});
})();
